<div class="auth-shell">
  <mat-card class="card-register auth-card">
    <h3 class="title">{{'signin' | traduccion}}</h3>
    <form class="register-form auth-form" [formGroup]="form" (ngSubmit)="login()">
      <mat-form-field appearance="outline" class="auth-form-field">
        <mat-label>{{'tenantId' | traduccion}}</mat-label>
        <mat-icon matPrefix>apartment</mat-icon>
        <input
          matInput
          formControlName="tenantId"
          name="tenantId"
          type="number"
          min="1"
          autocomplete="off">
      </mat-form-field>
      <div *ngIf="tenantId.invalid && (tenantId.dirty || tenantId.touched)" class="text-danger">
        <small *ngIf="tenantId.errors.required">{{'tenantId.errors.required' | traduccion}}<br></small>
        <small *ngIf="tenantId.errors.min">{{'tenantId.errors.min' | traduccion}}<br></small>
      </div>

      <mat-form-field appearance="outline" class="auth-form-field">
        <mat-label>{{'email' | traduccion}}</mat-label>
        <mat-icon matPrefix>email</mat-icon>
        <input
          matInput
          formControlName="usernameOrEmail"
          name="usernameOrEmail"
          type="email"
          autocomplete="username">
      </mat-form-field>
      <div *ngIf="usernameOrEmail.invalid && (usernameOrEmail.dirty || usernameOrEmail.touched)" class="text-danger">
        <small *ngIf="usernameOrEmail.errors.required">{{'email.errors.required' | traduccion}}<br></small>
        <small *ngIf="usernameOrEmail.errors.email">{{'email.errors.email' | traduccion}}<br></small>
      </div>

      <mat-form-field appearance="outline" class="auth-form-field">
        <mat-label>{{'password' | traduccion}}</mat-label>
        <mat-icon matPrefix>vpn_key</mat-icon>
        <input
          matInput
          formControlName="password"
          name="password"
          type="password"
          autocomplete="current-password">
      </mat-form-field>
      <div *ngIf="password.invalid && (password.dirty || password.touched)" class="text-danger">
        <small *ngIf="password.errors.required">{{'password.errors.required' | traduccion}}<br></small>
        <small *ngIf="password.errors.minlength">{{'password.errors.minlength' | traduccion}}<br></small>
      </div>

      <button mat-stroked-button color="primary" type="submit" [disabled]="!form.valid" class="btn-round auth-submit">
        {{'signin' | traduccion}}
      </button>
    </form>

    <!--
    <div class="forgot">
      <button mat-button type="button" (click)="_goTo('signup')" class="auth-link auth-link-primary">
        {{'want_signup' | traduccion}}
      </button>
    </div>-->
    <div class="forgot">
      <button mat-button type="button" (click)="_goTo('reset')" class="auth-link btn-terciary">
        {{'forgot_password?' | traduccion}}
      </button>
    </div>
  </mat-card>
</div>
